import { render, staticRenderFns } from "./FormTruckingInvoice.vue?vue&type=template&id=7c3d1a3d&"
import script from "./FormTruckingInvoice.vue?vue&type=script&lang=ts&"
export * from "./FormTruckingInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c3d1a3d')) {
      api.createRecord('7c3d1a3d', component.options)
    } else {
      api.reload('7c3d1a3d', component.options)
    }
    module.hot.accept("./FormTruckingInvoice.vue?vue&type=template&id=7c3d1a3d&", function () {
      api.rerender('7c3d1a3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TruckingAccountReceivable/FormTruckingInvoice.vue"
export default component.exports